import type { Id } from "../../convex/_generated/dataModel";
import type { TemplateId } from "../../convex/templateTypes";
import type { WeddingDetails } from "../components/builder/DetailsForm";
import type { TemplatePreviewPaletteId } from "./templatePalettes";

export const BUILDER_STATE_KEY = "builderState";
export const OWNERSHIP_TOKEN_KEY = "ownershipToken";
export const PENDING_SITE_SLUG_KEY = "pendingSiteSlug";

export interface SavedBuilderState {
  details: WeddingDetails;
  paletteId?: TemplatePreviewPaletteId;
  pendingAuth?: boolean;
  photoIds: Array<Id<"_storage">>;
  templateId: TemplateId;
}

export function readSavedBuilderState(): SavedBuilderState | null {
  if (typeof window === "undefined") {
    return null;
  }

  const saved = sessionStorage.getItem(BUILDER_STATE_KEY);
  if (!saved) {
    return null;
  }

  sessionStorage.removeItem(BUILDER_STATE_KEY);

  try {
    return JSON.parse(saved) as SavedBuilderState;
  } catch {
    return null;
  }
}

export function clearLegacyPendingSiteState() {
  if (typeof window === "undefined") {
    return;
  }

  localStorage.removeItem(PENDING_SITE_SLUG_KEY);
  localStorage.removeItem(OWNERSHIP_TOKEN_KEY);
}

export function clearBuilderFlowState() {
  if (typeof window === "undefined") {
    return;
  }

  clearLegacyPendingSiteState();
  sessionStorage.removeItem(BUILDER_STATE_KEY);
}
